export class YouthSearchURL {
    public static EndPoints = {
        youthsearch: '/jjis/services/youthservice/search',
        getYouthNoteBookPage: '/jjis/notebook/getYouthNoteBookPageNew',
        getYouthGenderList: '/platform/master/lookup/services/jjisMaster?type=SEX&limit=100&skip=0'
    }
}
